import { Box } from "@mui/system";
import { colorTheme } from "../const";

export default function Footer() {
  return (
    <Box sx={{ height: '36px', backgroundColor: `${colorTheme.palette.navy.main}` }}>
    </Box>
  )
}